import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import {EnrollError} from '../enroll-students-buses-system/enroll-error-interface'

@Injectable({
    providedIn: 'root'
})

export class BusStudentsService {
    token = localStorage.getItem('token');
    options = {
        headers: new HttpHeaders({
            // tslint:disable-next-line:object-literal-key-quotes
            'Authorization': `Bearer ${this.token}`
        })
    };
    constructor(private http: HttpClient) { }

    private _clearStudentData = new BehaviorSubject<boolean>(false);
    clearStudentData = this._clearStudentData.asObservable();


    clearAllStudents() {
        this._clearStudentData.next(true);
    }

    getClearAllStudents() {
        return this._clearStudentData;
    }

    private _clearSingleStudentData = new BehaviorSubject<any>(null);
    clearSingleStudentData = this._clearSingleStudentData.asObservable();


    clearSingleStudentFunc(obj) {
        this._clearSingleStudentData.next(obj);
    }

    getClearSingleStudent() {
        return this._clearSingleStudentData;
    }

    private _enrollErrors = new BehaviorSubject<EnrollError[]>([]);
    enrollErrors: Observable<EnrollError[]> = this._enrollErrors.asObservable();

    setEnrollErrors(errors: EnrollError[]) {
        this._enrollErrors.next(errors);
    }

    getEnrollErrors(): Observable<EnrollError[]> {
        return this.enrollErrors;
    }

    private _enrollDetails = new BehaviorSubject<any>({});
    enrollDetails: Observable<any> = this._enrollDetails.asObservable();

    setEnrollDetails(details: any) {
        this._enrollDetails.next(details);
    }

    getEnrollDetails(): Observable<any> {
        return this.enrollDetails;
    }


    deleteStudents(body) {
        let options = this.options;
        options['body'] = body;
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/bus/students/delete`, options);
    }

    getAllStudentsNotJoinedBusSystem(pagination, pageSize, sortby, sortOrder, search, pageNumber, filterValues) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/routes/join?is_paginated=${pagination}&per_page=${pageSize}&filter[is_joined]=0&sort[${sortby}]=${sortOrder}&search=${search}&page=${pageNumber}${this.getFilterString(filterValues)}`)
    }

    getAllStudentsInBusSystem(pagination, pageSize, sortby, sortOrder, search, pageNumber, filterValues) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/routes/join?is_paginated=${pagination}&per_page=${pageSize}&sort[${sortby}]=${sortOrder}&search=${search}&page=${pageNumber}${this.getFilterString(filterValues)}`)
    }

    exportAllStudentsInBusSystemReport(pagination, pageSize, sortby, sortOrder, search, pageNumber, filterValues) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/routes/join/export?is_paginated=${pagination}&per_page=${pageSize}&sort[${sortby}]=${sortOrder}&search=${search}&page=${pageNumber}${this.getFilterString(filterValues)}`)
    }
    getAvailableRoutes(pageSize, sortby, sortOrder, search, pageNumber, filterValues) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes?is_paginated=1&per_page=${pageSize}&sort[${sortby}]=${sortOrder}&search=${search}&page=${pageNumber}${this.getFilterString(filterValues)}`)
    }

    enrollStudentsInBusSystem(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/routes/join`, body);
    }

    getFilterString(filterValues) {
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        if (filterValues) {
            if (filterValues.grades !== undefined) {
                filterValues.grades.map((filterValue: string) => {
                    filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
                })
            }
            if (filterValues.classes !== undefined) {
                filterValues.classes.map((filterValue: string) => {
                    filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
                })
            }
        }
        return filterValuesForGradesApi + filterValuesForClassesApi;
    }

    getStudentsByIds(body) {
        return this.http.post(environment.url + `v2/students/by-ids`, body);
    }
}
